module.exports = __webpack_public_path__ + "img/test.dc88721c.png";